import { faGear, faGripDots, faGripDotsVertical } from "@fortawesome/pro-regular-svg-icons";
import { TTableBuilderDropdownOptionSections } from "../dropdown/TableBuilderDropdown";
import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { WEBSITE_BUILDER_Z_LAYERS } from "../../../utility/websiteBuilderZLayers";
import { ITableBuilderOptionProps, TableBuilderOption } from "./TableBuilderOption";
import "./tableBuilderOptionPlaceholder.scss";
import { useTranslation } from "react-i18next";

type TTableBuilderOptionPlaceholderType = "head-row" | "body-row" | "column";

interface ITableBuilderOptionPlaceholderProps {
  type: TTableBuilderOptionPlaceholderType;
  cellId: string;
  isDragging: boolean;
  optionSections: TTableBuilderDropdownOptionSections;
  dropdownOpen: boolean;
  toggleDropdown: () => void;
  dropdownRegistration?: (div: HTMLDivElement) => void;
}

export function TableBuilderOptionPlaceholder(props: ITableBuilderOptionPlaceholderProps) {
  const { type, cellId, isDragging, optionSections, dropdownOpen, toggleDropdown, dropdownRegistration } = props;

  const { t } = useTranslation();

  const containerRef = useRef<HTMLDivElement>(null);

  const [hovered, setHovered] = useState<boolean>(false);

  const showOption = hovered || isDragging || dropdownOpen;

  useEffect(() => {
    setHovered(false);
  }, [isDragging]);

  function getOptionProps(): ITableBuilderOptionProps {
    if (type === "head-row") {
      return {
        cellId,
        draggable: false,
        isDragging,
        icon: faGear,
        iconClassName: "gear-icon",
        optionSections,
        tooltipPlacement: "left",
        tooltipContent:
          <div>
            <b>{t("Click")}</b> {t("to open menu")}
          </div>,
        dropdownOpen,
        containerRef,
        toggleDropdown,
        dropdownRegistration,
      };
    } else if (type === "body-row") {
      return {
        cellId,
        draggable: true,
        isDragging,
        icon: faGripDotsVertical,
        iconClassName: "grip-dots-vertical-icon",
        optionSections,
        tooltipPlacement: "left",
        tooltipContent:
          <div>
            <div>
              <b>{t("Drag")}</b> {t("to move")}
            </div>
            <div>
              <b>{t("Click")}</b> {t("to open menu")}
            </div>
          </div>,
        dropdownOpen,
        containerRef,
        toggleDropdown,
        dropdownRegistration,
      };
    } else {
      return {
        cellId,
        draggable: true,
        isDragging,
        icon: faGripDots,
        iconClassName: "grip-dots-icon",
        optionSections,
        tooltipPlacement: "top",
        tooltipContent: 
          <div>
            <div>
              <b>{t("Drag")}</b> {t("to move")}
            </div>
            <div>
              <b>{t("Click")}</b> {t("to open menu")}
            </div>
          </div>,
        dropdownOpen,
        containerRef,
        toggleDropdown,
        dropdownRegistration,
      };
    }
  }

  return (
    <div
      ref={containerRef}
      className={classNames("table-builder-option-placeholder-container", {
        "head-row-container": type === "head-row",
        "body-row-container": type === "body-row",
        "column-container": type === "column",
      })}
      style={{
        zIndex: WEBSITE_BUILDER_Z_LAYERS.designSpace.sectionEntityOverride,
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={e => e.stopPropagation()}
    >
      {!showOption ? (
        <div className="table-builder-option-placeholder" />
      ) : (
        <TableBuilderOption {...getOptionProps()} />
      )}
    </div>
  );
}
